<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm cấu hình Giá gói dịch vụ/Thiết bị</h1>
      <div class="btn-group float-right">
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="saveAddConfig()"
        >
          <i class="bx bx-save"></i> Lưu
        </button>
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="checkCloseAdd()"
        >
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="configAdd" class="card-body px-20 mt-2 row">
        <form class="col-md-6">
          <ValidationProvider rules="required" vid="configType" name="Loại">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">Loại <span style="color: red">*</span></label>
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.configType"
                  :options="dataTypePackage"
                  placeholder="Loại"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="codeService" name="Dịch vụ áp dụng">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Dịch vụ áp dụng <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.codeService"
                  :options="dataConfigService"
                  placeholder="Dịch vụ áp dụng"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="customerType" name="Loại HĐ áp dụng">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Loại HĐ áp dụng <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.customerType"
                  :options="dataContractType"
                  placeholder="Loại HĐ áp dụng"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required|minMaxName_3" vid="name" name="Tên gói/Thiết bị">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Tên gói/ Thiết bị <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model="dataAdd.name"
                  type="text"
                  class="form-control"
                  placeholder="Tên gói/ Thiết bị"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required|minMaxName_3" vid="code" name="Mã gói/Thiết bị">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Mã gói/ Thiết bị <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model="dataAdd.code"
                  type="text"
                  class="form-control"
                  placeholder="Mã gói/ Thiết bị"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="amount" name="Đơn giá">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Đơn giá (VNĐ) <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model="dataAdd.amount"
                  type="number"
                  class="form-control"
                  placeholder="Đơn giá"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Mô tả</label>
            <div class="col-sm-7">
              <input
                v-model="dataAdd.description"
                type="text"
                class="form-control"
                placeholder="Mô tả"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="checkToActionModal(keyCheck)"
                    data-dismiss="modal"
                    v-if="keyCheck === 'success' || keyCheck === 'back'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { ConfigService } from '@/services/config-price.service'
  import { CommonService } from '@/services/common.service'
  import { SalesManagerService } from '@/services/sales-manager.service'

  export default {
    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataAdd: {},
        dataTypePackage: [
          { id: 'PACKAGE', text: 'Gói phần mềm' },
          { id: 'DEVICE', text: 'Thiết bị' },
        ],
        dataPackageDeviceName: [],
        dataConfigService: [],
        dataContractType: [
          { id: 'COMPANY', text: 'Doanh nghiệp' },
          { id: 'HOUSEHOLD', text: 'Hộ kinh doanh' },
          { id: 'INDIVIDUAL', text: 'Cá nhân' },
        ],
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: '',
        showLoading: false,
      }
    },

    created() {
      this.configSystem()
    },

    methods: {
      async checkCloseAdd() {
        this.keyCheck = 'back'
        this.showErr('Bạn có chắc chắn muốn huỷ bỏ thao tác không ?')
      },

      async closeAdd() {
        this.$router.push('/device-service-price-config')
      },

      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              data.data.services.map(e => this.dataConfigService.push({ id: e.code, text: e.name }))
              this.getListService()
            }
          })
          .catch(error => console.log(error))
      },
      async getListService() {
        try {
          const response = await SalesManagerService.getGroupService({})
          if (response.code === 1000) {
            this.dataGroupService = response.data.groupService
            const data = this.dataGroupService.filter(e => e.service === 'SELL')
            if (data[0].detail.length > 0) {
              data[0].detail.map(e => {
                const body = {
                  id: e.code,
                  text: this.serviceTypes(e.name),
                }
                this.dataConfigService.push(body)
              })
            }
          }
        } catch (error) {
          console.log(error, '=========>')
        }
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },

      async saveAddConfig() {
        try {
          const isSuccess = await this.$refs.configAdd.validate()
          if (!isSuccess) {
            this.keyCheck = 'cancel'
            this.showErr('Vui lòng điền đúng thông tin !')
            return
          }

          this.showLoading = true

          this.dataAdd.iconService = ''

          const response = await ConfigService.createConfig(this.dataAdd)
          if (response.code === 1000) {
            this.showModalNoti = true
            this.messNoti = 'Thêm mới gói thành công !'
            this.keyCheck = 'success'
            this.srcImage = require('@/assets/img/noti-success2.svg')
          } else {
            this.keyCheck = 'cancel'
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },

      checkToActionModal(keyCheck) {
        if (keyCheck === 'success' || keyCheck === 'back') {
          this.showModalNoti = false
          this.closeAdd()
        }
      },
    },
  }
</script>

<style scoped>
  .custom-placeholder,
  .custom-placeholder::placeholder {
    color: #999 !important;
  }
</style>
